import { HttpClient } from '../../httpClient'
import {
  OpalApiRequestBody,
  OpalApiRequestParams,
  OpalApiResponseDocument,
} from '../../schema'

type Params = OpalApiRequestParams<'CreateMomentCustomFieldV3'>
type RequestBody = OpalApiRequestBody<'CreateMomentCustomFieldV3'>
type Response = OpalApiResponseDocument<'CreateMomentCustomFieldV3', 201>

export function createMomentCustomField({
  params,
  requestBody,
}: {
  params: Params
  requestBody: RequestBody
}): Promise<Response> {
  const url = new URL(
    `/moments/v3/${params.path.moment_id}/moment_custom_fields`,
    window.location.origin
  )

  return HttpClient()
    .post(url.toString(), requestBody)
    .then((res) => res.data)
}
